import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress verbose logging in production to prevent leaking auth and WebSocket data
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
}

// Redirect to /resto/comanda/ if the URL doesn't match the app's base path.
// The individual CloudFront distribution serves the app at root, but React Router
// requires the basename prefix. This handles the case before the CFF redirect fires.
const BASE_PATH = '/resto/comanda';
if (!window.location.pathname.startsWith(BASE_PATH)) {
  const newPath = BASE_PATH + '/' + window.location.search + window.location.hash;
  window.location.replace(newPath);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar Service Worker para PWA
serviceWorkerRegistration.register();
